// removed by extract-text-webpack-plugin
module.exports = {"SummaryContainer":"CheckoutSummary__SummaryContainer__9g48t","SummaryDetailsContainer":"CheckoutSummary__SummaryDetailsContainer__2CNDx","BurgerContainer":"CheckoutSummary__BurgerContainer__2SWQs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckoutSummary/CheckoutSummary.css
// module id = 155
// module chunks = 0